export default __webpack_public_path__ + "static/media/logo-sanofi-regeneron.834ba4af.svg";